import DefaultTheme from './DefaultTheme';
const DarkTheme = { ...DefaultTheme,
  colors: { ...DefaultTheme.colors,
    button: { ...DefaultTheme.colors.button,
      secondary: '#000000',
      transparentBorder: '#000000'
    }
  }
};
export default DarkTheme;
//# sourceMappingURL=DarkTheme.js.map